import React, { useContext, useState } from 'react';

import '../styles/NewsletterBlock.css';
import isEmail from 'validator/lib/isEmail';
import getRecaptchaToken from '../helpers/getRecaptchaToken';
import AppContext from './context/AppContext';
import { string } from 'prop-types';

export default function NewsletterBlock({ newsletterText }) {
    const { appContext } = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [isValidRequest, setIsValidRequest] = useState(true);
    const [isVerifying, setIsVerifying] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const handleVerificationRequest = async () => {
        try {
            setIsVerifying(true);
            setIsVerified(false);
            setErrorMessage(null);
            if (!email
                || !isEmail(email)) {
                setIsValidRequest(false);
                setIsVerifying(false);
                return;
            }
            setIsValidRequest(true);
            const params = new URLSearchParams({
                email,
            }).toString();
            const response = await fetch(new URL(`/api/newsletterSubscriptions/subscribe?${params}`, process.env.APP_URL), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ token: await getRecaptchaToken(appContext.config.recaptchaSiteKey) }),
            });
            const data = await response.json();
            setIsVerifying(false);
            if (!data.success) {
                if (data.error) {
                    setErrorMessage(data.error);
                }
                setIsVerified(false);
                return;
            }
            setIsVerified(true);
        } catch (e) {
            setIsVerifying(false);
            setErrorMessage(e);
        }
    };
    return (<div
        className={'newsletter-block--container'}>
        <div
            className={'newsletter-block'}>
            <div>
                <p
                    className={'m-0 p-0 text-white'}><b>{newsletterText}</b></p>
                <p
                    className={'m-0 p-0 text-muted'}>Get the latest updates on new products and upcoming sales</p>
            </div>
            <div
                style={{
                    flexGrow: '1',
                    display: 'flex',
                    alignItems: 'center',
                }}>
                <div
                    className={'form-fields'}>
                    <div
                        className={'form-field form-field--input'}>
                        <input
                            type={'text'}
                            placeholder={'Email address'}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleVerificationRequest();
                                }
                            }} />
                    </div>
                    <div
                        className={'form-field form-field--submit'}>
                        <button
                            onClick={handleVerificationRequest}>subscribe</button>
                    </div>
                </div>
                {!isValidRequest && (<p
                    className={'mt-2 mb-0'}
                    style={{ color: 'blue' }}>
                    <strong>Invalid subscription request.</strong>
                </p>)}
                {isVerifying === true && (<p
                    className={'mt-2 mb-0'}
                    style={{ color: 'blue' }}>
                    <strong>Submitting request...</strong>
                </p>)}
                <p
                    className={'mt-2 mb-0'}
                    style={{
                        color: 'green',
                        display: isVerified ? 'block' : 'none',
                    }}>
                    <strong>Please check your email to confirm.</strong>
                </p>        {(!isVerifying && errorMessage !== null) && (
                    <p
                        className={'mt-2 mb-0'}
                        style={{ color: 'red' }}>
                        <strong>Error: {errorMessage ?? 'Failed.'}</strong>
                    </p>
                )}
            </div>
        </div>
    </div>);
}

NewsletterBlock.propTypes = {
    newsletterText: string,
};